import { Gesture } from "../../../../../../ui/gesture/component.js";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
//#region src/internal/skins/shared/skins/shared/live-video/gestures.tsx
/** @jsxImportSource react */
function LiveVideoGestures({ disabled = false } = {}) {
	return /* @__PURE__ */ jsxs(Fragment, { children: [
		/* @__PURE__ */ jsx(Gesture, {
			disabled,
			type: "tap",
			action: "togglePaused",
			pointer: "mouse",
			region: "center"
		}),
		/* @__PURE__ */ jsx(Gesture, {
			disabled,
			type: "tap",
			action: "toggleControls",
			pointer: "touch"
		}),
		/* @__PURE__ */ jsx(Gesture, {
			disabled,
			type: "doubletap",
			action: "toggleFullscreen",
			region: "center"
		})
	] });
}
//#endregion
export { LiveVideoGestures };

//# sourceMappingURL=gestures.js.map